import { api } from '../core/trpc'
import { useLocale } from './useLocale'

export const useWebContent = (section: string) => {
    const utils = api.useUtils()
    const { data: liveData } = api.webContent.getAllPublic.useQuery(undefined, {
        enabled: typeof window !== 'undefined',
    })
    const data = liveData ?? utils.webContent.getAllPublic.getData()
    const { getLocalizedValue } = useLocale()
    const sectionData = data?.find((c) => c.section === section)
    const content = sectionData?.content as Record<string, Record<string, string>> | undefined
    const getText = (key: string) => {
        const keyContent = content?.[key]
        if (!keyContent) {
            return ''
        }

        return getLocalizedValue(keyContent)
    }
    return { getText, isLoaded: !!data }
}
